<template>
  <div class="app-header level is-mobile">
    <div class="level-left">
      <div class="app-header__burger level-item is-hidden-tablet">
        <b-button
          class="is-inverted"
          icon-left="menu"
          outlined
          @click="menuToggleHandler"
        />
      </div>
      <div class="app-header__title level-item">
        <div class="title is-5">
          {{ title }}
        </div>
      </div>
      <slot name="left" />
    </div>
    <div class="level-right">
      <slot name="right" />
      <div v-if="hasSearch" class="level-item">
        <b-field>
          <b-input
            icon-clickable
            :value="searchQuery"
            :icon="searchQuery ? 'close' : 'magnify'"
            placeholder="Search..."
            type="search"
            @input="query => search({ query })"
            @icon-click="search({ query: null })"
          />
        </b-field>
      </div>
      <div class="level-item">
        <b-dropdown :mobile-modal="false" position="is-bottom-left">
          <b-button
            slot="trigger"
            class="navbar-item"
            icon-left="account"
            icon-right="menu-down"
            role="button"
            size="is-small"
          >
            <span class="app-header__user">
              {{ user.displayName || user.email }}
            </span>
          </b-button>

          <b-dropdown-item
            class="app-header__dropdown-item"
            @click="editProfileHandler"
          >
            <b-icon icon="pencil" size="is-small" />
            <span>
              Edit Profile
            </span>
          </b-dropdown-item>
          <b-dropdown-item
            class="app-header__dropdown-item"
            @click="signOutHandler"
          >
            <b-icon icon="logout" size="is-small" />
            <span>
              Logout
            </span>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import con from '../../store/mutationTypes';
import { auth } from '../../firebase';

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    resourceState: {
      type: String,
      required: false
    },
    hasSearch: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      searchQuery: function(state) {
        return state[this.resourceState].searchQuery;
      }
    })
  },
  methods: {
    search(...args) {
      this.$store.dispatch(`${this.resourceState}/search`, ...args);
    },
    editProfileHandler() {
      this.$store.commit(con.UPDATE_APP_STATE_NAMESPACED, {
        isEditingProfile: true
      });
    },
    menuToggleHandler() {
      this.$store.commit(con.UPDATE_APP_STATE_NAMESPACED, {
        isMenuOpen: true
      });
    },
    signOutHandler() {
      this.$buefy.dialog.confirm({
        message: `
        You will be logged out of the admin dashboard,
        do you want to proceed?`,
        confirmText: 'Logout',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async () => {
          await auth.signOut();
          window.location.reload();
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/mixins.sass';

.app-header {
  position: relative;
  flex: 0 0 0;
  width: 100%;
  height: $app-header-height;
  background-color: $app-header-background;
  box-shadow: $light-background-shadow;
  padding: 0.5rem 1rem;
  margin-bottom: 0;
  z-index: $app-header-z;

  &__title {
    padding: 0.5rem;
  }

  &__dropdown-item {
    display: inline-flex;
    align-items: center;

    span {
      margin-left: 0.5rem;
      display: inline-block;
      line-height: 1.2rem;
    }
  }

  &__user {
    display: none;

    @include tablet {
      display: inline-block;
      margin-left: 0.5rem;
    }
  }
}
</style>
